// components/PostAvatar.js
import React from "react";

export default function PostAvatar({
  post,
  users,
  myChatId,
  avatarUrl,
  onClick,
  size = 36, // ~w-9 h-9
}) {
 
const authorUser =
  String(post.author?.chatId) === String(myChatId)
    ? {
        profileImageUrl: avatarUrl,
      }
    : {
        profileImageUrl:
          post.author?.profileImageUrl ||
          users?.find(
            (u) =>
              String(u.chatId) ===
              String(post.author?.chatId)
          )?.profileImageUrl ||
          null,
      };
  const dimension = `${size}px`;

  return (
   <div
  onClick={onClick}
  style={{ width: dimension, height: dimension, minWidth: dimension }}
  className={`shrink-0 ${onClick ? "cursor-pointer" : ""}`}
>
      {authorUser?.profileImageUrl ? (
        <img
          src={authorUser.profileImageUrl}
          alt={post.author?.username || "User"}
          className="w-full h-full rounded-full object-cover"
        />
      ) : (
        <div className="w-full h-full rounded-full bg-neutral-300 dark:bg-neutral-700 flex items-center justify-center text-sm select-none">
          👤
        </div>
      )}
    </div>
  );
}